import { SubsectionsButtonsOptions } from './subsections-buttons-options.enum';

export const CookingApplianceOptions = { ...SubsectionsButtonsOptions };
export type CookingApplianceOptions = SubsectionsButtonsOptions;
